export default {
  SET_LIST(state, data) {
    state.listPrice = data.data;
    state.pagination = data.meta;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  CREATE(state, data) {
    state.listPrice.unshift(data);
  },
  UPDATE(state, data) {
    const index = state.listPrice.findIndex((u) => u.id === data.id);
    if (index >= 0) {
      state.listPrice.splice(index, 1, data);
    }
  },
  DELETE(state, id) {
    const index = state.listPrice.findIndex((u) => u.id === id);

    if (index >= 0) {
      state.listPrice.splice(index, 1);
    }
  },
};
